import { Form } from "antd";
import { useEffect } from "react";
import { FormModal } from "@/shared/components/FormModal";
import { useCreateTask } from "../hooks/useTasks";
import { useTasksStore } from "../store/tasks.store";
import { TaskForm, type TaskFormValues } from "./TaskForm";
import { buildCreateTaskRequest } from "./TaskFormModal";

/** Dedicated "Tezkor topshiriq" flow: priority is forced to URGENT. */
export function UrgentTaskFormModal() {
	const [form] = Form.useForm<TaskFormValues>();
	const { urgentModalOpen, closeUrgentModal } = useTasksStore();

	const { mutate: create, isPending: isCreating } = useCreateTask();

	useEffect(() => {
		if (urgentModalOpen) {
			form.resetFields();
			form.setFieldsValue({ priority: "URGENT" });
		}
	}, [urgentModalOpen, form]);

	const handleClose = () => {
		closeUrgentModal();
		form.resetFields();
	};

	const handleSubmit = () => {
		form
			.validateFields()
			.then((values) => {
				create(
					{ ...buildCreateTaskRequest(values), priority: "URGENT" },
					{ onSuccess: handleClose }
				);
			})
			.catch(() => {
				// Validation failed - Form shows errors inline
			});
	};

	return (
		<FormModal
			title="Tezkor topshiriq"
			open={urgentModalOpen}
			onCancel={handleClose}
			onOk={handleSubmit}
			confirmLoading={isCreating}
			width={720}
		>
			<TaskForm form={form} mode="urgent" />
		</FormModal>
	);
}
